import styled from 'styled-components';
import colors from '../../includes/colors';

export const Title = styled.h1`
  color: ${colors.black};
  font-size: 1.5rem;
  line-height: 1.75rem;
  font-weight: 300;
  margin-top: 20px;
  &.blue_variation {
    color: ${colors.blue};
  }
  @media (min-width: 576px) {
    font-size: 1.875rem;
    line-height: 2rem;
  }
  @media (min-width: 768px) {
    font-size: 2rem;
    line-height: 2.5rem;
  }
`;